import { type GroupOrderJoinPreviewQuery } from '../graphql/GroupOrderJoin.generated';

// ─────────────────────────────────────────────────────────────────────────────

export function getLocationDetails(params: GetLocationDetailsParams) {
  const { preview } = params;

  const typename = preview?.__typename;

  const restaurant = typename === 'MultipartyOrderPreviewSuccess' ? preview?.restaurant : undefined;
  const deliveryAddressSummary = typename === 'MultipartyOrderPreviewSuccess' ? preview?.deliveryAddressSummary : undefined; // prettier-ignore

  const orderChannel = getOrderChannel({ deliveryAddressSummary, restaurant });

  return {
    orderChannel,
    label: restaurant?.name, // NOTE: delivery info is not yet available
    address: deliveryAddressSummary ?? restaurant?.address,
    secondaryAddress: deliveryAddressSummary ? undefined : formatSecondaryAddress(restaurant),
  };
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function getOrderChannel(params: GetOrderChannelParams): GroupOrderChannel {
  const { deliveryAddressSummary, restaurant } = params;

  if (deliveryAddressSummary) return 'delivery';
  if (restaurant?.isOutpost) return 'outpost';

  return 'pickup';
}

function formatSecondaryAddress(address: MaybeSecondaryAddress) {
  const stateAndZip = [address?.state, address?.zipCode].filter(Boolean).join(' ');

  return [address?.city, stateAndZip].filter(Boolean).join(', ');
}

// ─── Types ───────────────────────────────────────────────────────────────────

type GroupOrderPreview = GroupOrderJoinPreviewQuery['multipartyOrderPreview'];
type GetLocationDetailsParams = { preview: GroupOrderPreview | undefined };
type GroupOrderChannel = 'delivery' | 'outpost' | 'pickup';

type MaybeSecondaryAddress =
  | { city?: string | null; state?: string | null; zipCode?: string | null }
  | undefined;

type GetOrderChannelParams = {
  deliveryAddressSummary?: string | null;
  restaurant?: { isOutpost?: boolean | null };
};
